import React from 'react';
import styled, { css } from 'styled-components';

const StyledFormElement = styled.div`
  margin-bottom: 1em;
  ${p => p.appearance === 'row'
    && css`
      display: flex;
      align-items: center;
    `}
`;

const FormElement = ({ children, ...props }) => (
  <StyledFormElement {...props}>{children}</StyledFormElement>
);

export default FormElement;
